module.exports = __webpack_public_path__ + "static/media/inf_27pog28p.0aef6423.mp3";